<template>
  <div class="wrapper">
    <v-chart
      ref="chart"
      class="chart"
      autoresize
      :option="option"
      :theme="theme"
    />
  </div>
</template>

<script>
import { use } from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';
import { mapState } from 'vuex';

use([
  SVGRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
]);

export default {
  name: 'LineEcharts',
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: 'dark',
  },
  props: {
    title: {
      type: String,
      default: () => '',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      option: {
        grid: {
          top: 20,
          left: 70,
          right: 10,
          // bottom: this.$vuetify.breakpoint.smAndDown ? 400 : 240,
        },
        xAxis: {
          type: 'category',
          data: [],
          position: 'top',
        },
        yAxis: {
          type: 'value',
        },
        tooltip: {
          confine: false,
          order: 'valueDesc',
          trigger: 'axis',
          position: ['0%', '85%'],
          textStyle: {
            fontSize: 12,
          },
          valueFormatter: value => this.$options.filters.currency(value),
        },
        // legend: {
        //   orient: 'horizontal',
        //   left: 'left',
        //   bottom: 'bottom',
        //   data: [],
        //   padding: [
        //     20, // up
        //     24, // right
        //     24, // down
        //     24, // left
        //   ],
        // },
        series: [],
      },
    };
  },
  computed: {
    ...mapState({
      theme: 'theme',
    }),
  },
  watch: {
    series: {
      async handler() {
        this.setOption();
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.$bus.$on('fullscreen', (fullscreen) => {
      const tooltip = { ...this.option.tooltip };
      if (fullscreen) {
        delete tooltip.position;
        tooltip.confine = true;
      } else {
        tooltip.position = ['0%', '85%'];
        tooltip.confine = false;
      }
      this.option.tooltip = tooltip;
      this.setOption();
    });
  },

  methods: {
    setOption() {
      if (this.$refs.chart) {
        this.$refs.chart.clear();
      }
      // this.option.legend.data = this.series.map(series => series.name);
      this.option.xAxis.data = this.labels;
      this.option.series = this.series;
      if (this.$refs.chart) {
        this.$refs.chart.setOption(this.option);
      }
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  min-height: 440px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrapper {
  height: 100%;
  padding: 8px;
}

.dark {
  color: #FFF;
}
</style>
